module.exports = __webpack_public_path__ + "static/media/about.d55f1490.jpg";